<script>
  import { onMount } from 'svelte'
  import ReviewerImage from '../../components/ReviewerProfile/ReviewerImage'
  import Reviewer from '../../components/ReviewerProfile/Reviewer'
  import DateChannel from '../../components/DateChannel/DateChannel.svelte'
  import Rating from '../../components/Rating.svelte'
  import ReviewImages from '../../components/ReviewImages.svelte'
  import Date from '../../components/Date.svelte'
  export let reviewChannel
  export let reviewContent
  export let reviewRating
  export let reviewerName
  export let reviewerEmail
  export let reviewerImage
  export let settings
  export let reviewImages
  export let reviewDate

  let starColor
  let textColor
  let verifiedText
  let widgetNameColor
  let contentFontSize
  let verifiedTextColor
  let profilePictureColor

  onMount(() => {
    starColor = settings.widget_settings.general_settings.star_rating_color
    textColor = '#000000'
    verifiedText = settings.translations.verified_reviewer
    widgetNameColor =
      settings.widget_settings.general_settings.reviewer_name_text_color

    contentFontSize =
      settings.widget_settings.general_settings.content_font_size
    verifiedTextColor =
      settings.widget_settings.general_settings.secondary_text_color
    profilePictureColor =
      settings.widget_settings.general_settings.profile_picture_color
  })
</script>

<style>
  .kbz_modal {
    padding: 10px;
    margin: 10px;
    text-align: left;
    font-size: 14px;
    margin-bottom: 30px;
    width: auto !important;
    height: auto !important;
    position: relative;
  }

  .kbz_modal_body {
    display: flex;
    clear: both;
    margin-bottom: 15px;
  }

  .kbz_modal_header {
    margin-bottom: 20px;
    height: 52px;
    display: flex;
  }

  #reviewer-profile {
    margin-bottom: 6px;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-right: 24px;
  }

  .review-content {
    line-height: 1.3;
    font-style: italic;
  }

  .review-content > :global(*.content-toggle) {
    color: #9163df;
  }

  .review-content > :global(*.content-toggle):hover {
    cursor: pointer;
  }
  .date {
    font-size: 12px;
  }

  .content-header {
    width: 100%;
  }
</style>

<div class="$style.kbz_modal">
  <div class="$style.kbz_modal_header">
    <div id="reviewer-image">
      <ReviewerImage
        {reviewerEmail}
        {reviewerImage}
        {reviewerName}
        {profilePictureColor} />
    </div>
    <div class="$style.content-header">
      <div id="reviewer-profile">
        <Reviewer
          {reviewerName}
          {textColor}
          {verifiedText}
          {widgetNameColor}
          {verifiedTextColor} />
        <div class="$style.date">
          <Date
            date={reviewDate}
            dateFormat={settings.widget_settings.general_settings.date_format} />
        </div>
      </div>

      <div id="review-rating">
        <Rating {starColor} reviewrating={reviewRating} />
      </div>
    </div>
    <div id="review-date">
      <DateChannel reviewchannel={reviewChannel} />
    </div>
  </div>
  <div class="$style.kbz_modal_body">
    <div
      class="$style.review-content"
      dir={settings.widget_settings.general_settings.text_direction}
      style={`color: ${textColor}; font-size: ${contentFontSize}px;`}>
      {@html reviewContent}
      <ReviewImages {reviewImages} />
    </div>
  </div>
</div>
